import Permission from "../Permission";
import {useMemo} from "react";

interface Props {
    permissions: string[];
    onChange: (permissions: string[]) => void;
    repository: string;
}

interface Permissions {
    name: string;
    description: string;
    possibleValues: {
        value: string;
        permissions: string[];
    }[];
}

export default function RepoPermissions({permissions, onChange, repository}: Props) {

    const permissionsList = useMemo(() => {
        return [
            {
                name: 'Repository',
                description: 'Permissions related to repository management.',
                possibleValues: [
                    {value: 'none', permissions: []},
                    {value: 'read', permissions: [`repo.${repository}.read`]},
                    {value: 'write', permissions: [`repo.${repository}.read`, `repo.${repository}.write`]},
                    {value: 'admin', permissions: [`repo.${repository}.read`, `repo.${repository}.write`, `repo.${repository}.admin`]},
                ]
            },
            {
                name: 'Assets',
                description: 'Read assets from repositories',
                possibleValues: [
                    {value: 'none', permissions: []},
                    {value: 'read', permissions: [`repo.asset.${repository}.read`]},
                ]
            },
            {
                name: 'Logs',
                description: 'Read logs from repositories',
                possibleValues: [
                    {value: 'none', permissions: []},
                    {value: 'read', permissions: [`repo.logs.${repository}.read`]},
                ]
            },
        ];
    }, [repository])

    return <>
        {permissionsList.map((permission) => {
            let value = undefined;
            let score = 0;

            for (const p of permission.possibleValues) {
                if (p.permissions.every(perm => permissions.includes(perm))) {
                    const tvalue = p.value;
                    const tscore = p.permissions.length;
                    if (value === undefined || tscore > score) {
                        value = tvalue;
                        score = tscore;
                    }
                }
            }

            return <Permission
                key={permission.name}
                permission={permission.name}
                description={permission.description}
                possibleValues={permission.possibleValues.map(value => value.value)}
                value={value ?? 'none'}
                setPermission={(value: string) => {
                    const newPermissions = permission.possibleValues.find(v => v.value === value)?.permissions || [];
                    const allPermissions: string[] = [];
                    for (const p of permission.possibleValues) {
                        allPermissions.push(...p.permissions);
                    }
                    const filteredPermissions = permissions.filter(p => !allPermissions.includes(p));
                    onChange([...filteredPermissions, ...newPermissions]);

                }}
            />
        })}
    </>

}
